const FETCH_COURSES = 'Fetch courses'
const FETCH_COURSES_SUCCESSFUL = 'Fetch courses successful'
const FETCH_COURSE = 'Fetch course'
const FETCH_COURSE_SUCCESSFUL = 'Fetch course successful'
const CREATE_COURSE_SUCCESSFUL = 'Create course successful'
const UPDATE_COURSE_SUCCESSFUL = 'Update course successful'

export default {
  FETCH_COURSES,
  FETCH_COURSES_SUCCESSFUL,
  FETCH_COURSE,
  FETCH_COURSE_SUCCESSFUL,
  CREATE_COURSE_SUCCESSFUL,
  UPDATE_COURSE_SUCCESSFUL
}



// WEBPACK FOOTER //
// ./src/app/reducers/constants/courseConstants.js